import templateUrl from './emptyTaskInstances.html';

class EmptyTaskInstancesCtrl {
  constructor(Authentication, ShiftTasksService, TaskTemplatesService, $state) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftTasksService, TaskTemplatesService, $state });
  }

  $onInit() {
    if (this.isManager) {
      this.TaskTemplatesService.loadTemplates();
    }
  }

  get isManager() {
    return this.Authentication.user.isManager;
  }

  get areTemplatesAvailable() {
    return this.TaskTemplatesService.allTemplates?.length;
  }

  get areFiltersEmpty() {
    return this.ShiftTasksService.areFiltersEmpty;
  }

  createTaskTemplate() {
    this.$state.go('shiftTasks.templates');
  }

  buildSchedule() {
    const { range, mode } = this.ShiftTasksService;
    const date = range ? range[0] : new Date();
    this.$state.go('shifts', {
      date,
      mode,
      tab: 'fullschedule',
    });
  }

  resetFilters() {
    this.ShiftTasksService.clearAllFilters();
  }
}

export default {
  templateUrl,
  controller: EmptyTaskInstancesCtrl,
  controllerAs: 'ctrl',
};
